import React from 'react';
import { string, object } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import '../../styles/thd-recs-containers.scss';

const VerticalRecsSubtitle = (props) => {
  const {
    scheme,
    metadata
  } = props;

  return (
    <>
      {scheme === 'pipcollection' && (
        <div className="sui-vertical-recs-subtitle sui-p-4">
          <Typography variant="body-base" weight="bold">
            <span>
              {metadata?.collectionTitle1}
              <span className="sui-px-2">|</span>
              {metadata?.collectionTitle2}
            </span>
          </Typography>
          <Typography variant="body-sm">
            <span className="sui-leading-tight">
              Find items that go well together
            </span>
          </Typography>
        </div>
      )}
      {scheme === 'battery_collection' && (
        <div className="sui-vertical-recs-subtitle sui-p-3">
          <Typography variant="body-sm">
            <span className="sui-leading-tight">
              Use the same battery and charger for all these tools
            </span>
          </Typography>
        </div>
      )}
    </>
  );
};

VerticalRecsSubtitle.propTypes = {
  scheme: string,
  // eslint-disable-next-line react/forbid-prop-types
  metadata: object
};

VerticalRecsSubtitle.defaultProps = {
  scheme: '',
  metadata: null
};

export { VerticalRecsSubtitle };